import React from 'react'
import { Field } from 'redux-form'
import { pt, buildPropTypes } from 'common-data/proptypehelpers'
import { FieldLayoutBox } from './FieldLayoutBox'
import { FieldValueFormatter, FieldValueParser, FieldValueConverters } from './FieldValueConverters'
import { Input } from 'reactstrap'
import { NumericFormat, PatternFormat } from 'react-number-format'
import _ from 'common-tools/LodashHelper'

export const NumberBoxTypes = {
  Basic: 'Basic',
  Currency: 'Currency',
  Phone: 'Phone'
}

class NumberBoxClass extends React.Component {
  static propTypes = buildPropTypes([

  ], {
    type: pt.string,
    defaultValue: pt.number
  })

  static defaultProps = {
    defaultValue: 0,
    type: NumberBoxTypes.Basic
  }

  renderBasic () {
    const { min, max, step, defaultValue, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, name, placeHolder, loading }) =>
          <Input type='number' step={step || 1} min={min} max={max} disabled={loading} invalid={showError} name={`numberbasic${name}`} id={`numberbasic${name}`} onChange={onChange} value={value || defaultValue || 0} />
        }
      </FieldLayoutBox>
    )
  }

  renderNumberFormatValueChange (values) {
    const { input: { onChange } } = this.props
    onChange(values.floatValue)
  }

  renderCurrency () {
    const { min, max, step, defaultValue, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, name, placeHolder, loading }) =>
          <NumericFormat thousandSeparator={true} prefix={'$'} disabled={loading} invalid={showError} name={`numbercurrency${name}`}
            id={`numbercurrency${name}`} decimalScale={2} fixedDecimalScale onValueChange={this.renderNumberFormatValueChange.bind(this)} value={value}
            customInput={Input} />
        }
      </FieldLayoutBox>
    )
  }

  renderPhone () {
    const { min, max, step, defaultValue, ...rest } = this.props
    return (
      <FieldLayoutBox {...rest}>
        {({ showError, value, onChange, name, placeHolder, loading }) =>
          <PatternFormat disabled={loading} invalid={showError} name={`numberphone${name}`}
            id={`numberphone${name}`} decimalScale={0} onValueChange={this.renderNumberFormatValueChange.bind(this)} value={value}
            customInput={Input} format="(###) ###-####" mask="_" />
        }
      </FieldLayoutBox>
    )
  }

  render () {
    const { type } = this.props

    if (_.isFunction(this[`render${type}`])) {
      return this[`render${type}`]()
    } else {
      return this.renderBasic()
    }
  }
};

export const NumberBox = ({ parse, format, fieldType = FieldValueConverters.Number, ...rest }) => { return <Field parse={fieldType ? FieldValueParser(fieldType) : parse} format={fieldType ? FieldValueFormatter(fieldType) : format} {...rest} component={NumberBoxClass} /> } // eslint-disable-line
NumberBox.FormatTypes = NumberBoxTypes

export default NumberBox
